<template>
  <main class="main">
    <v-row>
      <v-col cols="12" style="background-color: #f5f5f5">
        <v-card class="pa-5" shaped>
          <v-row>
            <v-col>
            <pre>{{proveedor}}</pre>
            <!-- AQUI VA EL COMPONENTE DATOS PROVEEDOR -->
            <DatosProveedor @datoscomprobante="setDataDocumentos"/>
            </v-col>
          </v-row>
            <TablaProductos/>
          <!-- AQUI VA TABLA PRODUCTOS -->
          <v-divider></v-divider>
        </v-card>
      </v-col>
    </v-row>
   

    <!--DIALOG PROCESANDO DATA-->
    <v-dialog v-model="procesardatos" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Procesando Factura...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </main>
</template>

<script>
import { mapGetters } from "vuex";
import Swal from "sweetalert2";
import axios from "axios";

//import moment from 'moment'
import moment from "moment-timezone";
moment.tz.setDefault("America/Guatemala");

import DatosProveedor from '../components/DatosProveedor'
import TablaProductos from '../components/TablaProductos';
export default {
  name: "FacturasCompras",
  components:{
        DatosProveedor,TablaProductos
  },
  data() {
    return {
      proveedor:null,
      procesardatos: false,
      modalproductos: false,
      idfactura: false,
      documento:{
        idestablecimiento:1
      }
    };
  },
  async created() {
    await this.initialize();
  },
  computed: {
    ...mapGetters([
      "getTokenUser",
      "getProductosActivos",
    ]),
    
  },
  methods: {
    
    async initialize() {
      await this.$store.dispatch("setProductos");
      await this.$store.dispatch("setAllEstablecimientos");
      await this.$store.dispatch('setExistencias',this.documento.idestablecimiento)  
      await this.$store.dispatch("setClientes");
      await this.$store.dispatch("setAllCompras");
      this.$store.dispatch("setNavigation");
    },

    setDataDocumentos(data){
      this.documento = data
    },
    
    async createCompra() {
      //POST VENTA
      if (!this.procesardatos) {
        this.procesardatos = true;
        const respuesta = await this.$store.dispatch(
          "createVenta",
          this.editedItem
        );
        if (respuesta.status > 299)
          this.errorSwal("Error al registrar la venta");

        this.idfactura = respuesta.data.idfactura;
        await this.createDetalleFactura();
        this.alertDone("Compra Registrada");
        this.$router.push("/compras");
        await this.$store.dispatch("setProductos");
      }
    },
    async createDetalleFactura() {
      const datos = [];
      this.carrito.forEach((item) => {
        item.idfactura = parseInt(this.idfactura);
        item.cantidad = parseInt(item.cantidad);
        item.preciocompra = parseFloat(item.preciocompra);
        item.descuento = parseFloat(item.descuento);
        item.precioventa = parseFloat(item.precioventa);
        item.idarticulo = parseInt(item.idarticulo);

        //Actualizamos el Stock
        this.precioPromedioProducto(item);

        datos.push(item);
      });

      await this.postFacturaDetalle(datos);
    },
    async postFacturaDetalle(data) {
      try {
        await axios.post(
          `${this.$store.state.urlapi}/facturadetalles/`,
          data,
          this.getTokenUser
        );
        this.procesardatos = false;
        this.clearData();
        this.modalProveedor = false;
      } catch (error) {
        console.log(error);
        this.errorSwal("Error al registrar Compra");
      }
    },
    clearData() {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedItemProveedor = Object.assign({}, this.defaultItemProveedor);
      this.carrito = [];
    },
    
    async precioPromedioProducto(item) {
      try {
        const producto = this.getProductosActivos.find(
          (elemento) => elemento.articulo.idarticulo === item.idarticulo
        );

        const precioCantidad =
          parseFloat(item.cantidad) * parseFloat(item.preciocompra) +
          parseFloat(producto.stockactual) * parseFloat(producto.preciocompra);
        const nuevoStock =
          parseFloat(item.cantidad) + parseFloat(producto.stockactual);

        if (producto.stockactual > 0) {
          const nuevoPrecioCompra = precioCantidad / nuevoStock;
          producto.stockactual = nuevoStock;
          producto.preciocompra = nuevoPrecioCompra;
        } else {
          producto.stockactual = parseFloat(item.cantidad);
          producto.preciocompra = parseFloat(item.preciocompra);
        }

        //Parsear Informacion
        delete producto.stockminimo;
        delete producto.preciosugerido;
        delete producto.preciominimo;
        delete producto.idcategoria;
        const idarticulo = producto.articulo.idarticulo;

        delete producto.articulo;
        delete producto.establecimiento;

        await axios.put(
          `${this.$store.state.urlapi}/articulostock/${this.idestablecimientoEmiter}/${idarticulo}`,
          producto,
          this.getTokenUser
        );
      } catch (error) {
        const existencias = {
          stockminimo: 1,
          stockactual: item.cantidad,
          articulo: item.idarticulo,
          establecimiento: this.idestablecimientoEmiter,
        };

        await this.$store.dispatch("postExistencias", existencias);
      }
    },
    
    //Notificaciones Swal
    alertDone(message) {
      Swal.fire({
        icon: "success",
        title: message,
        showConfirmButton: false,
        timer: 1500,
      });
    },
    errorSwal(message) {
      Swal.fire({
        icon: "error",
        title: message,
        text: "La factura no pudo ser procesada intentelo mas tarde",
      });
    },
    infoSwal(message, texto) {
      Swal.fire({
        icon: "info",
        title: message,
        text: texto,
      });
    },
  }
  
};
</script>
<style scoped>
.main {
  margin-top: -10px;
  height: 100vh;
}
.cliente {
  color: #3f51b5;
  font-size: 1.5em;
}
.resaltar {
  font-size: 25px;
  font-weight: 500;
}
</style>
